module.exports = Stripe;


//////////////////
// WEBPACK FOOTER
// external "Stripe"
// module id = 1283
// module chunks = 0